(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-technical-details"] && !Shopify.designMode) return;
  try {
    class ProductTechnicalDetails extends HTMLElement {
  #generation = 0;
  #controller;
  #variants = new Map();

  connectedCallback() {
    const data = this.querySelector('[data-variant-data]');
    try {
      this.#variants = new Map(JSON.parse(data?.textContent || '[]').map(variant => [String(variant.id), variant]));
    } catch {
      this.#variants = new Map();
    }
    document.addEventListener('shopify:product:select', this.#update);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:product:select', this.#update);
    this.#generation++;
    this.#controller?.abort();
  }

  #render(variant) {
    for (const [selector, key] of [['[data-technical-sku]', 'sku'], ['[data-technical-mpn]', 'mpn'], ['[data-technical-ean]', 'barcode']]) {
      const field = this.querySelector(selector);
      if (field) {
        const value = variant?.[key];
        field.textContent = value && value !== '-' ? value : '';
        field.closest('.detail-row').hidden = !field.textContent;
      }
    }
  }

  #update = async (event) => {
    const source = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    if (!source || source.closest('product-card, dialog') || String(source.dataset.productId) !== this.dataset.productId) return;
    const generation = ++this.#generation;
    this.#controller?.abort();
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.#generation) return;
      if (detail?.productId && String(detail.productId) !== this.dataset.productId) return;
      const selected = detail?.resource;
      const variant = this.#variants.get(String(selected?.id));
      if (variant || !selected?.id) {
        this.#render(variant);
        return;
      }
      this.#render({sku:selected.sku, barcode:selected.barcode});
      this.#controller = new AbortController();
      const url = new URL(source.dataset.productUrl || window.location.pathname, window.location.origin);
      url.searchParams.set('variant', selected.id);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, {signal:this.#controller.signal});
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!this.isConnected || generation !== this.#generation) return;
      const replacement = [...html.querySelectorAll('product-technical-details')].find(block => block.dataset.productId === this.dataset.productId);
      if (!replacement) return;
      const value = selector => replacement.querySelector(selector)?.textContent.trim() || '-';
      const resolved = {sku:value('[data-technical-sku]'), mpn:value('[data-technical-mpn]'), barcode:value('[data-technical-ean]')};
      this.#variants.set(String(selected.id), resolved);
      this.#render(resolved);
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('Produktinformationen konnten nicht aktualisiert werden.', error);
    }
  };
}

if (!customElements.get('product-technical-details')) {
  customElements.define('product-technical-details', ProductTechnicalDetails);
}
  } catch(e) { console.error(e); }
})();

})();
